import { AcoesPossiveis } from './perfil-profissiografico/acoes-possiveis';
import { Questionario } from './questionario';

/**
 * Concurso.
 */
export class Concurso {
	id?: number;
	nome?: string;
	utiliza_perfil?: boolean;
	codigo?: string;
	orientacao?: string;
	situacao?: string;
	questionario?: Questionario[];
	acoesPossiveis?: AcoesPossiveis[];

	constructor(id?: number, nome?: string, utiliza_perfil?: boolean, codigo?: string, orientacao?: string, situacao?: string) {
		this.id = id;
		this.nome = nome;
		this.utiliza_perfil = utiliza_perfil;
		this.codigo = codigo;
		this.orientacao = orientacao;
		this.situacao = situacao;
	}
}
